"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SyncSupplier_1 = require("@twii/core/lib/model/SyncSupplier");
var UserServiceContext_1 = require("../service/UserServiceContext");
var UserProfileStore = new SyncSupplier_1.SyncSupplier();
exports.UserProfileStore = UserProfileStore;
UserProfileStore.loader = function () {
    return UserServiceContext_1.UserServiceContext.value.getUserProfile();
};
